

export enum KalturaAppearInListType {
    categoryMembersOnly=3,
	partnerOnly=1
}